import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FirstMomentsAccordionProps {
  title: string;
  collapsedSummary?: string;
  expandedHint?: string;
  open: boolean;
  onToggle: () => void;
  children?: ReactNode;
}

export function FirstMomentsAccordion({
  title,
  collapsedSummary = "—",
  expandedHint,
  open,
  onToggle,
  children,
}: FirstMomentsAccordionProps) {
  return (
    <div className="overflow-hidden rounded-2xl border border-surfaces-z5 bg-surfaces-z3">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-lg p-lg text-left"
        onClick={onToggle}
        aria-expanded={open}
      >
        <div className="min-w-0">
          <p className="font-heading text-header-5 text-text-primary">
            {title}
          </p>
          {open && expandedHint ? (
            <p className="mt-xs font-body text-body-1 text-text-secondary">
              {expandedHint}
            </p>
          ) : (
            <p className="mt-xs font-mono text-body-3 font-medium text-text-tertiary">
              {collapsedSummary}
            </p>
          )}
        </div>
        <span className="flex size-11 shrink-0 items-center justify-center">
          <ChevronDown
            className={cn(
              "size-5 text-text-primary transition-transform",
              open && "rotate-180",
            )}
          />
        </span>
      </button>
      {open ? <div className="px-lg pb-lg">{children}</div> : null}
    </div>
  );
}
